export default __webpack_public_path__ + "static/add-719f8fb24877dd496d22330528562cf4.gif";